export const baseUrl = import.meta.env.VITE_APP_API_URL;
export const SIGNUP_PLAN_WAIT_TIME = 30000;

// options object for useSwr hook to prevent auto revalidation when fetching data for the first time
export const disableRevalidationForSwrOptions = {
	revalidateIfStale: false,
	revalidateOnFocus: false
};
